<!--
    @file:车辆定位 / 所有车辆 模块
-->
<template>
    <div id="all-cars">
        <v-ws v-on:onopen="createVehicleAll" :sendMessage="sendMessage" v-on:vehicle_all="changeData" v-on:vehicle_choose="changeHover" ></v-ws>
        <div class="poit-map" >
            <el-checkbox-group v-model="checkedStatus" @change="handleCheckedStatusChange" class="summary">
                <label class="info"></label>
                <el-checkbox label="alarm" key="0" class="alarm">{{ '报警中：' + statusList[0] + '辆' }}</el-checkbox>
                <el-checkbox label="run" key="1" class="running">{{ '运行中：' + statusList[1] + '辆'  }}</el-checkbox>
                <el-checkbox label="stop" key="2" class="stop">{{ '停止中：' + statusList[2] + '辆'  }}</el-checkbox>
                <label class="total">共{{ carSum }}辆</label>
            </el-checkbox-group>
            <div class="map-container">
                <div class="map">
                    <v-amap :poits="poits" :selectOne="selectOne" v-loading="loading" class="map" v-on:hover="hoverPoit"></v-amap>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import ws from '../plugins/ws';
import amapPoint from './map/amap-point';
export default {
    name: 'all-cars',
    data () {
        return {
            poits: [],
            savePoits: [],
            checkedStatus: ['alarm', 'run', 'stop'],
            statusList: [0, 0, 0],
            loading: true,
            carSum: 0,
            sendMessage: null,
            selectOne: {}
        };
    },
    components: {
        'v-amap': amapPoint,
        'v-ws': ws
    },
    methods: {
        changeData (data) {
            /**
             * 接收到ws传送的实时数据,更新页面数据
             *
             */
            this.savePoits = data;
            this.loading = false;
            this.handleCheckedStatusChange(this.checkedStatus);
            this.getSummary(data);
        },
        changeHover (data) {
            /**
             * 用户在地图中鼠标经过的点变化,改变信息狂的内容和位置
             *
             */
            this.selectOne = data;
        },
        createVehicleAll () {
            /**
             * 搜索所有的车辆
             *
             */
            this.sendMessage = {
                topic: 'vehicle_all',
                action: 'create'
            };
        },
        getSummary (data) {
            /**
             * 计算汇总所有车辆的状态
             *
             */
            var status = [];
            var sum = 0;
            for (var item in data) {
                sum += data[item].length;
                status.push(data[item].length);
            }
            this.carSum = sum;
            this.statusList = status;
        },
        getPoitData (data) {
            /**
             * 根据后端返回的数据,变成高德地图所需数据模式
             *
             */
            var poitsList = [];
            for (var item in data) {
                for (var j = 0, jlen = data[item].length; j < jlen; j++) {
                    data[item][j].groupId = item;
                    poitsList.push(data[item][j]);
                }
            }
            this.poits = poitsList;
        },
        handleCheckedStatusChange (value) {
            /**
             * 用户选择不同状态的车
             *
             */
            var data = {
                alarm: [],
                run: [],
                stop: []
            };
            for (var i = 0, len = value.length; i < len; i++) {
                data[value[i]] = this.savePoits[value[i]];
            }
            this.getPoitData(data);
            data = null;
        },
        hoverPoit (value) {
            /**
             * 鼠标经过地图上的点,发送获取车辆信息请求
             *
             * @param {Object} 高德地图maker的信息,只需要id用于获取对应的详细信息
             */
            this.sendMessage = {
                topic: 'vehicle_choose',
                action: 'create',
                data: {
                    id: value.id
                }
            };
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#all-cars{
    height: 100%;
}
.poit-map{
    height: 750px;
    margin: 15px  0;
    border:1px solid #e0e3e7;

}
.map-container{
    padding:5px;
    background-color: #fff;
}
.map{
    height: 700px;
}
.summary{
    background-color: #fff;
    padding: 10px 10px;
    text-align: left;
    border-bottom: 1px solid #e0e3e7;
}
.info{
    width: 18px;
    height: 19px;
    display: inline-block;
    background-image:url(../../assets/img/information.png);
    background-repeat: no-repeat;
    background-position: center;
    margin:0 8px -4px 0;
}
</style>
<style >
.summary .alarm{
    color:#ea0000;
}
.summary .running{
    color:#1e9600;
}
.summary .stop{
    color:#999999;
}
#all-cars .total{
    color:#5182e4;
    margin-left:20px;
}
.el-checkbox__inner{
    border-radius: 0;
    width: 14px;
    height: 14px;
    border-color: #5182e4;
}
.el-checkbox__inner::after{
    border: 1px solid #fff;
    border-left: 0;
    border-top: 0;
    top: 0;
    left: 4px;
}
.el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #5182e4;
}
</style>



// WEBPACK FOOTER //
// all-cars.vue?2d6a8c75